import PropTypes from 'prop-types';

const Heading = ({ cta1, cta2 }) => (
  <div>
    <h1 className="site-heading">{cta1}</h1>
    <p className="site-subheading">{cta2}</p>
  </div>
);

Heading.propTypes = {
  cta1: PropTypes.string.isRequired,
  cta2: PropTypes.string.isRequired,
};

export default Heading;
